export const it = {
    yes: "Sì",
    no: "No",
    newVersion: "É disponibile una nuova versione per questa applicazione. Vuoi ricaricare la pagina?",
    upgrade: "Nuova versione disponibile",
    termsLink: "https://www.kopjra.com/terms_it.html",
    privacyLink: "https://www.kopjra.com/privacy_it.html",
    codDest: "Codice Destinatario M5UXCR1",
    piva: "P.IVA 03904120247",
};
